import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetTreeDb } from '../redux/sheetTreeDbSlice';

const useSheetTreeDbsByBook = (bookId: string | undefined): [string[], SheetTreeDb[]] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const ids = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);
  ids.sort((a, b) => {
    const idA = sheetTreeDb.sheetTrees[a];
    const idB = sheetTreeDb.sheetTrees[b];
    return idA.order - idB.order;
  })
  const values = ids.map(id => sheetTreeDb.sheetTrees[id]);

  return [ids, values];
}

export default useSheetTreeDbsByBook;
